import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import { DebounceInput } from 'react-debounce-input';
import { UI } from '../../tokens';

// Prettier search box for the Progress task tables. The drawer surface is dark, so a plain
// outlined TextField reads as a hard, dark box. Instead this is a clean light pill with a
// leading search icon, muted placeholder and a soft accent focus glow.
const searchFieldSx = {
  mx: 2,
  my: 1,
  width: '90%',
  '& .MuiOutlinedInput-root': {
    backgroundColor: UI.surface,
    borderRadius: UI.radiusPill,
    color: UI.textPrimary,
    transition: 'box-shadow .15s ease',
    '& fieldset': { borderColor: 'transparent' },
    '&:hover': { boxShadow: '0 1px 4px rgba(26,36,45,0.18)' },
    '&:hover fieldset': { borderColor: 'transparent' },
    '&.Mui-focused': { boxShadow: '0 0 0 2px rgba(70,191,131,0.4)' },
    '&.Mui-focused fieldset': { borderColor: 'transparent' },
  },
  '& .MuiOutlinedInput-input': {
    py: 0.75,
    fontSize: 14,
    '&::placeholder': { color: UI.textMuted, opacity: 1 },
  },
};

export default function TaskSearchField({
  value,
  onChange,
  placeholder = 'Search',
  sx,
}) {
  return (
    <DebounceInput
      element={TextField}
      placeholder={placeholder}
      variant="outlined"
      size="small"
      value={value}
      onChange={onChange}
      debounceTimeout={300}
      sx={[searchFieldSx, ...(Array.isArray(sx) ? sx : [sx])]}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchRoundedIcon sx={{ fontSize: 18, color: UI.textMuted }} />
          </InputAdornment>
        ),
      }}
    />
  );
}
